export type GroupContextType = {
  is: (id: string) => boolean;
};

export default function useGroup() {
  const is = (id: string) => {
    return id.startsWith("spdgrp_");
  };

  return {
    is,
  };
}
